module.exports = __webpack_public_path__ + "img/SKWINKELNetActieEvaluatiesCA526C.2be0e94a.png";